import { CSSProperties, FC } from 'react';
import classNames from 'classnames';
import { sanitize } from 'isomorphic-dompurify';

type EyebrowProps = {
  text: string;
  align?: 'center' | 'left';
  className?: string;
  style?: CSSProperties;
};

export const Eyebrow: FC<EyebrowProps> = ({ text, className, align = 'left', style }) => {
  if (!text) return null;

  const alignmentClasses = {
    center: 'items-center text-center',
    left: 'items-start',
  };

  return (
    <div className={classNames('flex flex-col', alignmentClasses[align], className)} style={style}>
      <span
        className={classNames(
          'text-xl uppercase leading-6',
          align === 'center' ? 'text-center' : ''
        )}
        dangerouslySetInnerHTML={{ __html: sanitize(text) }}
      />
      <span className="mt-3 block h-0.5 w-24 bg-accent" />
    </div>
  );
};
